import { render, staticRenderFns } from "./bMall0rderManage.vue?vue&type=template&id=7fd3248e&scoped=true"
import script from "./bMall0rderManage.vue?vue&type=script&lang=js"
export * from "./bMall0rderManage.vue?vue&type=script&lang=js"
import style0 from "./bMall0rderManage.vue?vue&type=style&index=0&id=7fd3248e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fd3248e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7fd3248e')) {
      api.createRecord('7fd3248e', component.options)
    } else {
      api.reload('7fd3248e', component.options)
    }
    module.hot.accept("./bMall0rderManage.vue?vue&type=template&id=7fd3248e&scoped=true", function () {
      api.rerender('7fd3248e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/_homeCloudPlatform/mall/bMall0rderManage.vue"
export default component.exports